<template>
    <ul class="list" :class="[sizeString ? 'list-' + sizeString : '']">
        <slot/>
    </ul>
</template>

<script>
import ListMixin from "../ListMixin";

    export default {
        name: "InfoList",

        mixins: [ListMixin]
    }
</script>
<style>
/*********************
  Inputs
**********************/
/*********************
  Typography
**********************/
/*********************
  Inputs
**********************/
/*********************
  Shadows
**********************/
/*********************
  Layout
**********************/
/*********************
  Card
**********************/
/*********************
  Opacity
**********************/
/* ==========================================================================
   Mixins
   ========================================================================== */
.list {
  padding-left: 0 !important;
  list-style: none;
  margin: 0;
}
.list li, .list .list-item {
  padding: 3px 0;
  margin: 0;
  display: flex;
  font-size: 0.9rem;
  color: #5e6b6b;
}
.list li > .icon:first-child:not(:only-child), .list .list-item > .icon:first-child:not(:only-child) {
  align-items: start;
}
.list li > .icon:first-child:not(:only-child) > i, .list li > .icon:first-child:not(:only-child) > svg, .list li > a.avatar:first-child:not(:only-child), .list li > img:first-child:not(:only-child), .list li > .image-wrapper:first-child:not(:only-child), .list .list-item > .icon:first-child:not(:only-child) > i, .list .list-item > .icon:first-child:not(:only-child) > svg, .list .list-item > a.avatar:first-child:not(:only-child), .list .list-item > img:first-child:not(:only-child), .list .list-item > .image-wrapper:first-child:not(:only-child) {
  margin-right: 8px;
  min-width: 1rem;
  width: 1.4rem;
  height: 1rem;
  text-align: center;
  color: #bebebe;
  font-size: 0.95rem;
}
.list li svg, .list .list-item svg {
  min-width: inherit;
  width: inherit;
  height: inherit;
}
.list li > span:last-child > .icon:not(:only-child) > i, .list li > span:last-child > .icon:not(:only-child) svg, .list .list-item > span:last-child > .icon:not(:only-child) > i, .list .list-item > span:last-child > .icon:not(:only-child) svg {
  margin-left: 5px;
  color: #bebebe !important;
  font-size: 16px;
  width: 16px;
  height: 16px;
}
@media (max-width: 767px) {
  .list li > span:last-child > .icon:not(:only-child) > i, .list li > span:last-child > .icon:not(:only-child) svg, .list .list-item > span:last-child > .icon:not(:only-child) > i, .list .list-item > span:last-child > .icon:not(:only-child) svg {
    display: none;
  }
}
.list li > .btn:last-child, .list .list-item > .btn:last-child {
  margin-left: 5px;
}
.list li > a.avatar:first-child, .list li > img:first-child, .list .list-item > a.avatar:first-child, .list .list-item > img:first-child {
  width: 1rem;
  height: 1rem;
}
.list li a, .list .list-item a {
  color: inherit;
}
.list li a:hover, .list .list-item a:hover {
  color: #008200;
}
.list li *, .list .list-item * {
  margin: 0;
  line-height: 1.2;
  text-align: left;
  color: inherit;
}
.list li.sub-li, .list .list-item.sub-li {
  margin-left: 10px;
  padding: 3px;
  color: #7D8484;
}
.list li.sub-li > svg:first-child, .list .list-item.sub-li > svg:first-child {
  min-width: 0.8rem;
  width: 1.2rem;
  height: 0.8rem;
}
.list li.sub-li + li:not(.sub-li), .list .list-item.sub-li + li:not(.sub-li) {
  margin-top: 5px;
}
.list.list-lg li, .list.list-lg .list-item {
  font-size: 1rem;
  margin: 10px 0;
}
.list.list-lg li > .icon:first-child > i, .list.list-lg li > .icon:first-child > svg, .list.list-lg li > a.avatar:first-child, .list.list-lg li > img:first-child, .list.list-lg li > .image-wrapper:first-child, .list.list-lg .list-item > .icon:first-child > i, .list.list-lg .list-item > .icon:first-child > svg, .list.list-lg .list-item > a.avatar:first-child, .list.list-lg .list-item > img:first-child, .list.list-lg .list-item > .image-wrapper:first-child {
  margin-right: 16px;
  width: 1.2rem;
  height: 1.2rem;
  font-size: 1.2rem;
}
@media (max-width: 639px) {
  .list.list-lg li, .list.list-lg .list-item {
    font-size: 1rem;
    margin: 8px 0;
  }
  .list.list-lg li > .icon:first-child > i, .list.list-lg li > .icon:first-child > svg, .list.list-lg li > a.avatar:first-child, .list.list-lg li > img:first-child, .list.list-lg li > .image-wrapper:first-child, .list.list-lg .list-item > .icon:first-child > i, .list.list-lg .list-item > .icon:first-child > svg, .list.list-lg .list-item > a.avatar:first-child, .list.list-lg .list-item > img:first-child, .list.list-lg .list-item > .image-wrapper:first-child {
    margin-right: 12px;
    width: 1.1rem;
    height: 1.1rem;
    font-size: 1.1rem;
  }
}
.list.list-sm li, .list.list-sm .list-item {
  font-size: 13px;
}
.list.list-sm li > .icon:first-child > i, .list.list-sm li > .icon:first-child > svg, .list.list-sm li > a.avatar:first-child, .list.list-sm li > img:first-child, .list.list-sm li > .image-wrapper:first-child, .list.list-sm .list-item > .icon:first-child > i, .list.list-sm .list-item > .icon:first-child > svg, .list.list-sm .list-item > a.avatar:first-child, .list.list-sm .list-item > img:first-child, .list.list-sm .list-item > .image-wrapper:first-child {
  width: 1rem;
  height: 0.85rem;
  font-size: 0.9rem;
}
.list.list-sm li *, .list.list-sm .list-item * {
  line-height: 1.2;
}
.list.list-xs li, .list.list-xs .list-item {
  font-size: 12px;
}
.list.list-xs li > .icon:first-child > i, .list.list-xs li > .icon:first-child > svg, .list.list-xs li > a.avatar:first-child, .list.list-xs li > img:first-child, .list.list-xs li > .image-wrapper:first-child, .list.list-xs .list-item > .icon:first-child > i, .list.list-xs .list-item > .icon:first-child > svg, .list.list-xs .list-item > a.avatar:first-child, .list.list-xs .list-item > img:first-child, .list.list-xs .list-item > .image-wrapper:first-child {
  width: 1rem;
  height: 0.85rem;
  font-size: 0.9rem;
}
.list.list-center li, .list.list-center .list-item {
  justify-content: center;
}
</style>